export const FILTER_CONFIG = {
  asset_table: {
    filter: [
      { name: "interval", adv: true },
      { name: "category", field: "type" },
      { name: "sub_category", field: "filter" },
    ],
  },
};
